import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

import type { EmailThread } from '@stuut/api/models';

import { useEmailProcessingStore } from '@/store/emailProcessing';
import { getProcessingLabel, resolveEmailThreadProcessingStep } from '@/types/emailProcessing';

export function useEmailProcessingState(thread: MaybeRefOrGetter<EmailThread>) {
  const { processingSteps } = useEmailProcessingStore();

  const processingStep = computed(() =>
    resolveEmailThreadProcessingStep(toValue(thread), processingSteps),
  );

  const isProcessing = computed(() => !!processingStep.value);

  const processingLabel = computed(() =>
    processingStep.value ? getProcessingLabel(processingStep.value) : undefined,
  );

  return { processingStep, isProcessing, processingLabel };
}
